import "./IssuancePanel.css";

import { ReactElement } from "react";

import { InteractionObjectType } from "../../constants";
import { ProjectIssuanceBNGPanelData, ProjectIssuanceCarbonPanelData, ProjectIssuanceNNPanelData } from "../../models";
import { GenericModal } from "../../route/developer/components";
import { Column, ErrorBox, FlyoutPanel, Row } from "../../widget";
import { TagsPanel } from "..";
import { IssuancePanelDynamic } from "./components";
import { useIssuancePanel } from "./useIssuancePanel";

interface IssuancePanelProps {
  issuance?: ProjectIssuanceBNGPanelData | ProjectIssuanceCarbonPanelData | ProjectIssuanceNNPanelData;
  show: boolean;
  onClose: () => void;
  handleRefresh: () => void;
}

export const IssuancePanel = ({ issuance, show, onClose, handleRefresh }: IssuancePanelProps): JSX.Element => {
  const {
    errors,
    handleClosePanel,
    handleSubmit,
    handleSubmitForm,
    isHandleSubmitLoading,
    issuanceSchema,

    showTagsPanel,
    setShowTagsPanel,

    tagPills,
    changedTagsExternal,
    setChangedTagsExternal,

    setRefreshTags,

    standardSpecificIssuanceData,
    setStandardSpecificIssuanceData,
    showIssuanceTransactionWarning,
    setShowIssuanceTransactionWarning,
    issuanceTransactionCount,
    verifierData,
  } = useIssuancePanel({ issuance, onClose, handleRefresh });

  const renderErrors = (): ReactElement | undefined => {
    return errors && errors.length > 0 ? (
      <Row spacingV="ll">
        <Column span={12}>
          <ErrorBox text={errors.map((error) => error.message)} />
        </Column>
      </Row>
    ) : undefined;
  };

  const content = (): ReactElement => {
    return (
      <IssuancePanelDynamic
        issuanceData={standardSpecificIssuanceData}
        setIssuanceData={setStandardSpecificIssuanceData}
        handleClosePanel={handleClosePanel}
        handleSubmit={handleSubmitForm}
        isHandleSubmitLoading={isHandleSubmitLoading}
        issuanceSchema={issuanceSchema}
        setShowTagsPanel={setShowTagsPanel}
        tags={tagPills}
        verifierData={verifierData}
        isEditing={issuance !== undefined}
      />
    );
  };
  return (
    <FlyoutPanel
      show={show}
      onClose={handleClosePanel}
      size="Large"
      contentChildren={
        <>
          {renderErrors()}
          {content()}
          <TagsPanel
            objectUuid={issuance?.uuid ?? undefined}
            objectType={InteractionObjectType.ISSUANCE}
            show={showTagsPanel}
            onClose={() => setShowTagsPanel(false)}
            shouldRefreshTags={() => setRefreshTags((prev) => !prev)}
            changedTagsExternal={changedTagsExternal}
            setChangedTagsExternal={setChangedTagsExternal}
          />
          <GenericModal
            data={{
              title: "Edit issuance?",
              text: [
                `This issuance has ${issuanceTransactionCount} ${
                  issuanceTransactionCount === 1 ? "transaction" : "transactions"
                } recorded. Editing this issuance may make these transactions invalid.`,
                "Do you wish to proceed?",
              ],
              confirmText: "Yes",
              cancelText: "No",
            }}
            show={showIssuanceTransactionWarning}
            onConfirm={() => handleSubmit()}
            closeModal={() => setShowIssuanceTransactionWarning(false)}
          />
        </>
      }
      header={`${issuance === undefined ? "Add" : "Edit"} issuance`}
      buttonsChildren={undefined}
      height="Full"
    />
  );
};
